import { RateioDespesas } from "./RateioDespesas";
import { Produto } from "./Produto";

export class PedidoAssociado {
  codigoPedido: number;
  tipo: string;
  dataLancamento: Date;
  criacaoAutomaticaMrvPag: boolean;

  idPedidoAssociado: number;
  idProtocolo: number;
  idSapPedidoContrato: string;
  loginUsuarioLancamento: string;
  idsapFornecedor: string;
  idsapGrupoComprador: string;
  desSapGrupoComprador: string;
  tipoPedido: string;
  valorTotal: string;
  cidade: string;
  status: string;
  cnpjFontePagadora: string;
  usuarioAprovador: string;
  dataAprovacao: Date;
  empresa: string;
  localNegocio: string;
  divisao: string;
  centro: string;
  miro: boolean;
  servico: boolean;
  migo: boolean;
  dataAssociacao: Date;
  loginAssociacao: string;
  dataAprovacaoSld: Date;
  condicaoPagamento: string;
  
  rateios: RateioDespesas[];
  produtos: Produto[];
}

